/* src/app/admin-dashboard/site-system/records/machine-log/machine-log.css */
/*# sourceMappingURL=machine-log.css.map */
